// extracted by mini-css-extract-plugin
module.exports = {"not_found":"manage-approved-sp_not_found__3glin"};